<template>
  <v-container class="notifications">
    <div class="notifications__main">
      <v-flex tag="h2">{{ emailConstants.EMAILS }}</v-flex>
      <v-flex v-if="success" class="alert__box__success" xs12>
        <v-icon>check</v-icon>
        {{ emailConstants.SAVE_CONFIRMATION }}
      </v-flex>
      <v-flex v-if="error" class="alert__box__failure" xs12>
        <v-icon>check</v-icon>
        {{ emailConstants.SAVE_ERROR }}
      </v-flex>
      <v-flex mb-3 tag="h4">{{ emailConstants.COMMUNITY_ACTIVITY }}</v-flex>
      <v-flex class="notifications__list-details">
        <v-expansion-panel>
          <v-container v-if="forums && forums.length > 0" class="member">
            <v-expansion-panel-content class="my-community">
              <div slot="header">
                <v-layout class="my-community__header" row wrap>
                  <v-flex class="title" md4><i class="far fa-plus-square"></i> {{ privacySettingsConstants.MY_FORUMS }}
                    ({{ forums.length }})
                  </v-flex>
                </v-layout>
              </div>
              <v-flex class="my-community__expand">
                <v-layout
                    v-for="forum in forums"
                    :key="forum.id"
                    class="my-community__expand__section"
                    row
                    wrap>
                  <v-flex class="desc">{{ forum.communityName || emailConstants.YPO_DEFAULT_FORUM }}
                    <v-tooltip v-if="forum.communityName === emailConstants.YPO_BOARD" slot="append" right>
                      <i slot="activator" class="fas fa-info-circle"></i>
                      <span>{{ emailConstants.YPO_Champion }}</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex md4 text-xs-right>
                    <strong>{{ emailConstants.SEND_UPDATES }}</strong>
                    <v-select v-model="forum.settingType" :disabled="forum.communityName === emailConstants.YPO_BOARD"
                              :items=emailConstants.EMAIL_UPDATES
                              attach
                              data-qe-id="forum_email-setting_select"
                              solo
                              v-on:change="setEmailSettings()"></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-expansion-panel-content>
          </v-container>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-container v-if="chapters && chapters.length" class="member">
            <v-expansion-panel-content class="my-community">
              <div slot="header">
                <v-layout class="my-community__header" row wrap>
                  <v-flex class="title" md4>
                    <i class="far fa-plus-square"></i>
                    {{ privacySettingsConstants.MY_CHAPTERS }} ({{ chapters.length }})
                  </v-flex>
                </v-layout>
              </div>
              <v-flex class="my-community__expand">
                <v-layout
                    v-for="(chapter) in chapters"
                    :key="chapter.id"
                    class="my-community__expand__section"
                    row
                    wrap>
                  <v-flex class="desc">{{ chapter.communityName || emailConstants.YPO_DEFAULT_CHAPTER }}
                    <v-tooltip v-if="chapter.communityName === emailConstants.YPO_BOARD" slot="append" right>
                      <i slot="activator" class="fas fa-info-circle"></i>
                      <span>{{ emailConstants.YPO_Champion }}</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex md4 text-xs-right>
                    <strong>{{ emailConstants.SEND_UPDATES }}</strong>
                    <v-select v-model="chapter.settingType" :disabled="chapter.communityName === emailConstants.YPO_BOARD"
                              :items=emailConstants.EMAIL_UPDATES
                              attach
                              data-qe-id="chapter_email-setting_select"
                              solo
                              v-on:change="setEmailSettings()"></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-expansion-panel-content>
          </v-container>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-container v-if="networks && networks.length > 0" class="member">
            <v-expansion-panel-content class="my-community">
              <div slot="header">
                <v-layout class="my-community__header" row wrap>
                  <v-flex class="title" md4>
                    <i class="far fa-plus-square"></i>
                    {{ privacySettingsConstants.MY_NETWORKS }} ({{ networks.length }})
                  </v-flex>
                </v-layout>
              </div>
              <v-flex class="my-community__expand">
                <v-layout
                    v-for="(network) in networks"
                    :key="network.id"
                    class="my-community__expand__section"
                    row
                    wrap>
                  <v-flex class="desc">{{ network.communityName || emailConstants.YPO_DEFAULT_NETWORK }}
                    <v-tooltip v-if="network.communityName === emailConstants.YPO_BOARD" slot="append" right>
                      <i slot="activator" class="fas fa-info-circle"></i>
                      <span>{{ emailConstants.YPO_Champion }}</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex md4 text-xs-right>
                    <strong>{{ emailConstants.SEND_UPDATES }}</strong>
                    <v-select v-model="network.settingType" :disabled="network.communityName === emailConstants.YPO_BOARD"
                              :items=emailConstants.EMAIL_UPDATES
                              attach
                              data-qe-id="network_email-setting_select"
                              solo
                              v-on:change="setEmailSettings()"></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-expansion-panel-content>
          </v-container>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-container v-if="regions.length > 0" class="member">
            <v-expansion-panel-content class="my-community">
              <div slot="header">
                <v-layout class="my-community__header" row wrap>
                  <v-flex class="title" md4><i class="far fa-plus-square"></i> {{ privacySettingsConstants.MY_REGIONS }}
                    ({{ regions.length }})
                  </v-flex>
                </v-layout>
              </div>
              <v-flex class="my-community__expand">
                <v-layout
                    v-for="(region) in regions"
                    :key="region.id"
                    class="my-community__expand__section"
                    row
                    wrap>
                  <v-flex class="desc">{{ region.communityName || emailConstants.YPO_DEFAULT_REGION }}
                    <v-tooltip v-if="region.communityName === emailConstants.YPO_BOARD" slot="append" right>
                      <i slot="activator" class="fas fa-info-circle"></i>
                      <span>{{ emailConstants.YPO_Champion }}</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex md4 text-xs-right>
                    <strong>{{ emailConstants.SEND_UPDATES }}</strong>
                    <v-select v-model="region.settingType" :disabled="region.communityName === emailConstants.YPO_BOARD"
                              :items=emailConstants.EMAIL_UPDATES
                              attach
                              color="ypo_blue"
                              data-qe-id="region_email-setting_select"
                              solo
                              v-on:change="setEmailSettings()"></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-expansion-panel-content>
          </v-container>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-container v-if="groups && groups.length > 0" class="member">
            <v-expansion-panel-content class="my-community">
              <div slot="header">
                <v-layout class="my-community__header" row wrap>
                  <v-flex class="title" md4><i class="far fa-plus-square"></i> {{ privacySettingsConstants.MY_GROUPS }}
                    ({{ groups.length }})
                  </v-flex>
                </v-layout>
              </div>
              <v-flex class="my-community__expand">
                <v-layout
                    v-for="(group) in groups"
                    :key="group.id"
                    class="my-community__expand__section"
                    row
                    wrap>
                  <v-flex class="desc">{{ group.communityName || emailConstants.YPO_DEFAULT_GROUP }}
                    <v-tooltip v-if="group.communityName === emailConstants.YPO_BOARD" slot="append" right>
                      <i slot="activator" class="fas fa-info-circle"></i>
                      <span>{{ emailConstants.YPO_Champion }}</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex md4 text-xs-right>
                    <strong>{{ emailConstants.SEND_UPDATES }}</strong>
                    <v-select v-model="group.settingType" :disabled="group.communityName === emailConstants.YPO_BOARD || group.communityName === emailConstants.PHISHING_NOTIFICATIONS"
                              :items=emailConstants.EMAIL_UPDATES
                              attach
                              color="ypo_blue"
                              data-qe-id="group_email-setting_select"
                              solo
                              v-on:change="setEmailSettings()"></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-expansion-panel-content>
          </v-container>
        </v-expansion-panel>
      </v-flex>
      <v-flex
          class="requestbtn"
          mb-4
          text-xs-left
          xs12>
        <RequestNewGroup></RequestNewGroup>
      </v-flex>
      <status-overlay :action="loadEmailInformationAction" content-height="500px"></status-overlay>
      <v-container v-for="(communicationPreferences, heading) in emailInformation.communicationPreferences" :key="heading"
                   class="member">
        <v-flex mb-3 tag="h4">{{ heading }}</v-flex>
        <v-expansion-panel v-for="(subhead, subheader) in Object.keys(communicationPreferences)" :key="subheader">
          <v-container class="member">
            <v-expansion-panel-content class="my-community">
              <div slot="header">
                <v-layout class="my-community__header flex-grow-overwrite-all" row wrap>
                  <v-flex class="title pr-2"><i class="far fa-plus-square"></i></v-flex>
                  <v-flex class="title">{{ subhead }}</v-flex>
                </v-layout>
              </div>
              <v-flex class="my-community__expand">
                <v-layout
                    v-for="(preferences, options, index) in Object.values(communicationPreferences[subhead]).filter(x => !x.hideForumLetter)"
                    :key="options"
                    class="my-community__expand__section"
                    row
                    wrap>
                  <v-checkbox
                      :id="preferences.preferenceSalesforceValue"
                      v-model="preferences.isPreferenceEnabled"
                      :data-qe-id="`email-preference_${index}_checkbox`"
                      :disabled="preferences.isDisabled"
                      :label="preferences.preferenceDescriptiveLabel"
                      class="desc check-container"
                      color="ypo_blue"
                      @change="preferences.preferenceSalesforceValue === emailConstants.SELECT_ALL
                                    ? setEmailSettings(communicationPreferences[subhead])
                                    : onCheckboxChange(preferences, communicationPreferences[subhead])">
                  </v-checkbox>
                  <v-tooltip
                      v-if="preferences.isDisabled"
                      slot="append"
                      class="ml-2"
                      right>
                    <i slot="activator" class="fas fa-info-circle"></i>
                    <span>{{ emailConstants.YPO_Champion }}</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>
            </v-expansion-panel-content>
          </v-container>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-content class="my-community">
            <div slot="header">
              <v-layout class="my-community__header" row wrap>
                <v-flex class="title"><i class="far fa-plus-square"></i> {{ emailConstants.YPO_ACCOUNT }}</v-flex>
              </v-layout>
            </div>
            <v-flex class="my-community__expand">
              <v-layout
                  v-for="YPOAccountConstants in YPOAccountConstants.options"
                  :key="YPOAccountConstants.key"
                  class="my-community__expand__section"
                  row
                  wrap>
                <v-checkbox
                    :label="YPOAccountConstants.title"
                    class="desc"
                    color="ypo_blue"
                    disabled
                    input-value="true">
                </v-checkbox>
              </v-layout>
            </v-flex>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-container>
    </div>
    <div class="notifications__footer">
      <v-layout row wrap>
        <v-flex text-xs-center xs12>
          <v-progress-linear v-show="addEmailAction && addEmailAction.pending" class="ma-0"
                             indeterminate></v-progress-linear>
          <v-btn class="primary_btn transparent" data-qe-id="emailSettings_cancelBtn" @click="cancel()">
            {{ appCommonConstants.CANCEL }}
          </v-btn>
          <v-btn
              :disabled="isDisabled"
              class="primary_btn"
              data-qe-id="emailSettings_saveBtn"
              @click="submitEmailSettings()">{{ appCommonConstants.SAVE }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import {
  privacySettingsConstants,
  emailConstants,
  YPOAccountConstants,
  championOptions,
  forumOptions,
} from "./privacysettings.constants.js";
import { mapActions, mapGetters, mapState } from 'vuex';
import { storeAction } from '../../store/storeActions.constant';
import { storeGetters } from '../../store/storeGetters.constant';
import { appCommonConstants } from "../appCommon.constants.js";
import { VProgressLinear } from 'vuetify/es5/components/VProgressLinear';
import StatusOverlay from '../StatusOverlay/StatusOverlay';
import orderBy from "lodash/orderBy";
import RequestNewGroup from '../GroupPage/RequestNewGroup';

export default {
  name: "EmailSettings",
  components: {
    VProgressLinear,
    StatusOverlay,
    RequestNewGroup,
  },
  data: () => ({
    privacySettingsConstants,
    emailConstants,
    appCommonConstants,
    YPOAccountConstants,
    championOptions,
    forumOptions,
    forums: [],
    chapters: [],
    networks: [],
    regions: [],
    groups: [],
    isDisabled: true,
    success: false,
    error: false,
  }),
  created() {
    this.getEmailInformation();
  },
  methods: {
    ...mapActions({
      getEmailInformation: `myAccount/${storeAction.getEmailPreferences}`,
      saveEmailSettings: `myAccount/${storeAction.saveEmailPreferences}`,
    }),
    checkForChanges() {
      this.isDisabled = false;
    },
    async cancel() {
      await this.getEmailInformation();
      this.isDisabled = true;
    },
    setEmailSettings(communicationPreferences) {
      this.isDisabled = false;
      this.success = false;
      this.error = false;
      const allPreference = communicationPreferences.find(pref => pref.preferenceSalesforceValue === emailConstants.SELECT_ALL);

      if (allPreference.isPreferenceEnabled) {
        // When "All" is selected, enable all
        communicationPreferences.forEach((pref) => {
          pref.isPreferenceEnabled = true;
        });
      } else {
        // When "All" is deselected, disable all
        communicationPreferences.forEach((pref) => {
          pref.isPreferenceEnabled = false;
        });
      }

      // Check for changes
      this.checkForChanges();
    },
    onCheckboxChange(preference, communicationPreferences) {
      if (preference.preferenceSalesforceValue !== emailConstants.SELECT_ALL) {
        const allPreference = communicationPreferences.find(pref => pref.preferenceSalesforceValue === emailConstants.SELECT_ALL);
        if (!preference.isPreferenceEnabled && allPreference.isPreferenceEnabled) {
          allPreference.isPreferenceEnabled = false;
        }
        const allChecked = communicationPreferences.every(pref =>
                pref.isPreferenceEnabled ||
                pref.preferenceSalesforceValue === emailConstants.SELECT_ALL);
        if (allChecked) {
          allPreference.isPreferenceEnabled = true;
        }
      }
      this.checkForChanges();
    },
    submitEmailSettings() {
      const cleanedPreferences = {};
      Object.keys(this.emailInformation.communicationPreferences).forEach((categoryKey) => {
        const category = this.emailInformation.communicationPreferences[categoryKey];
        cleanedPreferences[categoryKey] = {};

        Object.keys(category).forEach((subhead) => {
          cleanedPreferences[categoryKey][subhead] = category[subhead].filter(pref => pref.preferenceSalesforceValue !== emailConstants.SELECT_ALL);
        });
      });
      const postBody = {
        emailSettings: [
          ...this.forums,
          ...this.chapters,
          ...this.networks,
          ...this.regions,
          ...this.groups,
        ],
        communicationPreferences: cleanedPreferences,
      };
      this.saveEmailSettings(postBody)
          .then(() => {
            this.scrollToTop();
            this.isDisabled = true;
            this.success = true;
            this.getEmailInformation();
          })
          .catch(() => {
            this.scrollToTop();
            this.error = true;
            this.isDisabled = true;
          });
    },
    scrollToTop() {
      let y1 = window.scrollY;
      y1 -= 100;
      document.body.scrollTop = y1;
      document.documentElement.scrollTop = y1;
      if (y1 > 0) {
        const self = this;
        setTimeout(() => {
          self.scrollToTop();
        }, 10);
      }
    },
    sortCommunitiesByAsc(communities) {
      return orderBy(communities, "communityName", "asc");
    },
  },
  computed: {
    ...mapGetters({
      emailInformation: `myAccount/${storeGetters.emailInformation}`,
      emailPreferencesResponse: `myAccount/${storeGetters.emailPreferencesResponse}`,
    }),
    ...mapState('actionState', ['actions']),
    addEmailAction() {
      return this.actions[storeAction.saveEmailPreferences];
    },
    loadEmailInformationAction() {
      return this.actions[storeAction.getEmailPreferences];
    },
  },
  watch: {
    emailInformation(val) {
      if (val.emailSettings) {
        this.forums = this.sortCommunitiesByAsc(val.emailSettings.filter(i => i.recordTypeName === this.privacySettingsConstants.FORUM));
        this.chapters = this.sortCommunitiesByAsc(val.emailSettings.filter(i => i.recordTypeName === this.privacySettingsConstants.CHAPTER));
        this.networks = this.sortCommunitiesByAsc(val.emailSettings.filter(i => i.recordTypeName === this.privacySettingsConstants.NETWORK));
        this.regions = this.sortCommunitiesByAsc(val.emailSettings.filter(i => i.recordTypeName === this.privacySettingsConstants.REGION));
        this.groups = this.sortCommunitiesByAsc(val.emailSettings.filter(i => i.recordTypeName === this.privacySettingsConstants.GROUP));
      }
      if (val.communicationPreferences) {
        Object.keys(val.communicationPreferences).forEach((key) => {
          let disableOptions = [];
          if (val.championPositionStatus === false) {
            disableOptions = championOptions.defaultOptions.map(x => x.title);
          }
          if (val.hasForumModeratorPosition === true) {
            disableOptions = [...disableOptions, ...forumOptions.forumModerator.map(x => x.title)];
          }
          const forumRemove = forumOptions.ForumWiseNewsletter.map(x => x.title);
          Object.values(val.communicationPreferences[key]).forEach((rec) => {
            rec.forEach((data) => {
              if (disableOptions.includes(data.preferenceDescriptiveLabel)) {
                data.isDisabled = true;
                data.isPreferenceEnabled = true;
              }
              if (forumRemove.includes(data.preferenceDescriptiveLabel)) {
                data.hideForumLetter = true;
              }
            });
          });
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/responsive.scss";

.notifications {
  background: $white;
  position: relative;

  &__main {
    margin-bottom: 70px;

    @include breakpoint(xs) {
      margin-bottom: 140px;
    }
  }

  &__footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: $ypo-tile-border;
    padding: 10px;

    @include breakpoint(xs) {
      background-color: $white;
      height: 130px;
      border-top: 1px solid $ypo-medium-gray;
    }
  }

  h2 {
    color: $ypo-blue;
    font-family: Raleway, serif;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: -0.3px;
    margin-bottom: 10px;
  }

  h4 {
    background-color: $ypo-blue;
    color: $white;
    font-family: "Noto Sans";
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    padding: 5px 5px;
  }

  h6 {
    color: $ypo-dark-gray;
    font-family: Raleway, serif;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.09px;
    line-height: 24px;
    margin-bottom: 25px;

    i {
      color: $ypo-gold;
    }
  }

  .desc {
    color: $ypo-dark-gray;
    font-family: Raleway, serif;
    font-size: 16px;
    letter-spacing: 0.09px;
    line-height: 22px;
    padding: 0 0 0 0;
    font-weight: 500;
  }

  .alert__box {
    &__success {
      background: $ypo-gold;
      color: $white;
      position: relative;
      padding: 10px 0 10px 80px;
      font-size: 12px;
      text-transform: initial;
      line-height: normal;
      margin-left: -3px;
      margin-bottom: 10px;

      i {
        font-size: 28px !important;
        color: $white !important;
        position: absolute;
        left: 40px;
        top: 0;
        bottom: 0;
      }
    }

    &__failure {
      background: $ypo-red;
      color: $white;
      position: relative;
      padding: 10px 0 10px 80px;
      font-size: 12px;
      text-transform: initial;
      line-height: normal;
      margin-left: -3px;
      margin-bottom: 10px;

      i {
        font-size: 28px !important;
        color: $white !important;
        position: absolute;
        left: 40px;
        top: 0;
        bottom: 0;
      }
    }
  }

  .member {
    color: $ypo-blue;
    font-family: 'Noto Sans', sans-serif;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: -0.18px;
    line-height: 40px;
    padding: 0;
    margin-bottom: 15px;
  }

  .communities {
    background: $ypo-extra-light-gray;
    margin-bottom: 15px !important;
  }

  @include breakpoint(xs) {
    .requestbtn {
      text-align: center !important;
      margin: 20px 0 0;
    }

    h2 {
      padding: 0px 20px 0px 20px;
      font-size: 18px;
      line-height: inherit;
      font-weight: 500;
    }

    h6 {
      padding: 5px 20px 0px 20px;
      font-size: 14px;
      line-height: inherit;
      font-weight: 500;
      color: $black;
    }

    h4 {
      font-size: 16px;
      font-weight: normal;
      margin: 20px;
    }

    .member {
      font-size: 14px;
      max-width: 800px;
      width: 800px;
      font-weight: 500;
    }

    &__list-details {
      width: 500px;
      overflow: auto;
      padding: 0 20px;

      .options {
        max-width: 800px;
        width: 800px;

        strong {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/responsive.scss";

.notifications {
  .v-expansion-panel {
    box-shadow: none;
  }

  .my-community {
    border-top: 0 !important;

    .v-expansion-panel__header {
      padding: 0;
      @include breakpoint(xs) {
        max-width: 420px;
      }
    }

    .v-expansion-panel {
      box-shadow: none !important;
    }

    .v-text-field.v-text-field--enclosed .v-text-field__details {
      display: none;
    }

    .v-select > .v-input__control > .v-input__slot {
      margin-bottom: 0;
      box-shadow: none;
      background: none;
      border-bottom: 1px $ypo-medium-gray solid;
      border-radius: 0;
      padding: 0;
      font-weight: 500;
    }

    .v-text-field.v-text-field--solo .v-label {
      font-size: 14px;
    }

    .v-select__selection {
      font-size: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      display: inline-block;
      max-width: 168px;
    }

    .v-text-field.v-text-field--solo .v-input__control {
      min-height: 30px;
      padding: 0;
    }

    .v-select {
      display: inline-block;
      margin-left: 10px;
      max-width: 200px;
    }

    .v-expansion-panel__header__icon {
      display: none;
    }

    &__header {
      background-color: $ypo-tile-bgcolor;
      padding: 15px 25px 15px 10px;
      align-items: center;
      margin-bottom: 10px;

      .title {
        color: $ypo_blue;
        text-transform: uppercase;
        font-size: 18px !important;
        font-weight: bold;

        @include breakpoint(xs) {
          max-width: 350px;
        }

        i {
          margin-right: 10px;
        }
      }

      .v-expansion-panel {
        .theme--light.v-icon {
          display: none !important;
        }
      }
    }

    &__expand {
      align-items: center;

      .title {
        color: $ypo-title-blue-gray;
        font-size: 15px !important;
        padding-left: 18px;
      }

      &__section {
        align-items: center;
        padding: 0px 70px 0px 40px;
        transition: 0.3s all ease;

        &:hover {
          background: $ypo-extra-light-gray;
        }

        .check-container {
          display: inline-block;
          flex: initial;

        }

        .v-input--selection-controls .v-input__slot {
          margin-bottom: 0px;

          label {
            font-family: Raleway, serif;
            font-weight: 500;
            color: $ypo-dark-gray !important;
            @include breakpoint(xs) {
              max-width: 270px;
            }
          }
        }
      }

      .fa-info-circle {
        color: $ypo-gold;
        cursor: pointer;
      }

      .fa-info-circle {
        color: $ypo-gold;
        cursor: pointer;
      }
    }

    strong {
      color: $ypo_blue;
      font-size: 16px;
    }

    &.v-expansion-panel__container--active {
      .fa-plus-square {
        &:before {
          content: "\F146";
        }
      }

      .v-messages {
        min-height: 4px;
      }
    }
  }

  .requestbtn {
    .v-btn {
      margin: 0;
      padding: 10px 70px;
      font-size: 16px;
      border: 1px solid $ypo-blue !important;
    }
  }
}
</style>
